export default {
    'unexpected_error': 'A apărut o eroare neașteptată'
}
